import React from "react";
import Tooltip from "@hyro-components/Tooltip";
import StyledIconButton from "./HyroIconButton.styles";
import { ICON_BUTTON_VARIANTS, ICON_BUTTON_SIZES, ICON_COLOR_MODES } from "./HyroIconButton.consts";

const HyroIconButton = ({
  children,
  tooltip,
  variant = ICON_BUTTON_VARIANTS.OUTLINED,
  size = ICON_BUTTON_SIZES.MEDIUM,
  active = false,
  iconColorMode = ICON_COLOR_MODES.STROKE,
  hasHoverStyle = true,
  ...buttonProps
}) => {
  const buttonElement = (
    <StyledIconButton
      variant={variant}
      size={size}
      active={active}
      iconColorMode={iconColorMode}
      hasHoverStyle={hasHoverStyle}
      disableRipple={!hasHoverStyle}
      {...buttonProps}>
      {children}
    </StyledIconButton>
  );

  if (tooltip) {
    return (
      <Tooltip title={tooltip} placement="top">
        {buttonElement}
      </Tooltip>
    );
  }

  return buttonElement;
};

export default HyroIconButton;
